import React, { useRef, useEffect, useContext } from 'react'
import UpNext from '../topic-detail-page/components/UpNext'
import {
  useVideoAssessmentEnrolmentQuery,
  useVideoAssessmentEnrolmentCompletionQuery
} from './VideoAssessmentPage.codegen'
import './VideoAssessmentPage.less'
import { TopicDetailContext } from '../topic-detail-page/TopicDetailContext'

export interface IVideoAssessmentPage {
  shareId: number
  isPathway: boolean
}

export const VideoAssessmentPage = (props: IVideoAssessmentPage) => {
  const { topic, pathway, nextInPathway } = useContext(TopicDetailContext)
  const formRef = useRef(null)
  const { data } = useVideoAssessmentEnrolmentQuery({
    variables: {
      id: props.shareId
    },
    fetchPolicy: 'no-cache'
  })

  const {
    data: enrolmentData,
    startPolling,
    stopPolling
  } = useVideoAssessmentEnrolmentCompletionQuery({
    variables: {
      id: props.shareId
    },
    fetchPolicy: 'no-cache'
  })

  useEffect(() => {
    if (data && data.enrolment?.bongoParams) {
      const { current } = formRef
      setTimeout(function () {
        // @ts-expect-error
        current.submit()
      }, 1000)
    }
  }, [data])

  if (!data?.enrolment) {
    return null
  }

  const bongoParams = data.enrolment?.bongoParams

  if (props.isPathway) {
    startPolling(5000)
    if (enrolmentData?.enrolment?.completion_date) {
      stopPolling()
    }
  }

  return (
    <div className="VideoAssignmentPage">
      <div className="IframeContainer">
        <iframe
          name="bongoIframe"
          allowFullScreen
          allow="camera *; microphone *; display-capture *"
        />
      </div>
      <form
        key="bongoForm"
        ref={formRef}
        name="ltiLaunchForm"
        id="ltiLaunchForm"
        method="POST"
        target="bongoIframe"
        encType="application/x-www-form-urlencoded"
        action={bongoParams.base_url}
      >
        {Object.keys(bongoParams).map((key) => {
          if (key !== 'base_url') {
            return (
              <input
                key={key}
                type="hidden"
                name={key}
                value={bongoParams[key]}
              />
            )
          }
        })}
      </form>
      {props.isPathway &&
        pathway &&
        nextInPathway &&
        topic &&
        nextInPathway.id !== topic.id &&
        enrolmentData?.enrolment?.completion_date && (
          <div className="upnext-page-wrapper">
            <UpNext pathway={pathway} topic={nextInPathway} />
          </div>
        )}
    </div>
  )
}
